var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAviva = function SvgAviva(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#aviva_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0069B4",
    d: "M46.907 32.475v-.881h-.314v-.14h.83v.14h-.314v.881zM48.77 32.475h-.202v-.795c-.111.285-.229.537-.34.795h-.112c-.107-.258-.218-.537-.325-.795v.795h-.165v-1.02h.25c.107.252.272.65.309.778.048-.134.229-.537.346-.779h.24zM27.682 34.371c.17.033.777.21.777.645V42h2.056v-7.881h-2.833v.252M11.502 34.119v.247c.25.054.788.204.57.698L9 42h1.597l.959-2.149h3.396L15.793 42h2.13l-3.013-7.881zm.533 4.738 1.379-3.1 1.203 3.1zM43.047 34.119v.247c.25.054.788.204.57.698L40.55 42h1.598l.958-2.149h3.397l.84 2.149h2.13l-3.018-7.881zm.533 4.738 1.379-3.1 1.203 3.1zM37.59 42l3.253-7.881h-1.555l-2.385 5.77-2.273-5.77h-2.896v.247a1.06 1.06 0 0 1 .878.645l2.747 6.984zM23.311 42l3.253-7.881h-1.539l-2.385 5.77-2.273-5.77h-2.891v.247a1.06 1.06 0 0 1 .878.645l2.742 6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    d: "M34.662 27.704 33.294 13.5l-1.385 14.44q1.347-.15 2.753-.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64B445",
    d: "M38.005 27.602V13.5h-4.711l1.368 14.204a56 56 0 0 1 3.343-.102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069B4",
    d: "m31.91 27.94 1.389-14.44H20.974v17.148a38.2 38.2 0 0 1 10.93-2.686z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aviva_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 13.5h40.5V42H9z"
  })))));
};
export { SvgAviva as ReactComponent };
export default __webpack_public_path__ + "images/aviva.svg";